export const getTemplate = async (templateId: string) => {
    const templateLink = templateId;

    const res = await fetch(templateLink);
    const template = await res.text();

    return template;
}